export default "__VITE_ASSET__JPMz8gJ8__"